<template>
  <section>
    <v-slide-y-transition>
      <v-row v-if="!not_in_autralia">
        <v-col class="py-0" :cols="withName ? 5 : 12">
          <v-text-field
            v-model="postcode"
            ref="postInput"
            v-validate="'required|min:4|numeric'"
            :error-messages="errors.collect('postcode')"
            mask="####"
            label="Postcode"
            hint="It must be an Australian postcode"
            data-vv-name="postcode"
            data-vv-as="postcode"
            required
          />
        </v-col>
        <v-col class="py-0" v-if="withName" cols="7">
          <v-text-field
            v-model="name_text"
            v-validate="'required'"
            :error-messages="errors.collect(`${label ? label : 'name'}`)"
            :label="label ? label : 'Name'"
            :hint="`Enter ${label ? label : ''} name`"
            :data-vv-name="`${label ? label : 'name'}`"
            :data-vv-as="`${label ? label : 'name'}`"
            @input="getInfo"
            required
          />
        </v-col>
        <v-col class="py-0" cols="12">
          <a href="javascript:void(0)" @click="showNotInCountry">
            Not in Australia?
          </a>
        </v-col>
      </v-row>
    </v-slide-y-transition>
    <v-slide-y-transition>
      <v-row v-if="not_in_autralia">
        <v-col class="py-0" :cols="withName ? 5 : 12">
          <v-select
            v-model="country"
            ref="countrySelect"
            v-validate="'required'"
            :error-messages="errors.collect('Country')"
            label="Country"
            data-vv-name="Country"
            data-vv-as="country"
            required
            :items="countries"
          ></v-select>
        </v-col>
        <v-col class="py-0" v-if="withName" cols="7">
          <v-text-field
            v-model="name_text"
            v-validate="'required'"
            :error-messages="errors.collect('school_text')"
            :label="label ? label : 'Name'"
            :hint="`Enter ${label ? label : 'Name'} name`"
            data-vv-name="school_text"
            data-vv-as="school"
            @input="getInfo"
            required
          />
        </v-col>
        <v-col class="py-0" cols="12">
          <span>
            <a href="javascript:void(0)" @click="showInCountry">
              {{ `${label ? label + ' is' : 'Residing'} in Australia?` }}
            </a>
          </span>
        </v-col>
      </v-row>
    </v-slide-y-transition>
  </section>
</template>

<script>
import Countries from '../../../public/countries.json'

export default {
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    withName: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      postcode: null,
      not_in_autralia: false,
      name_text: null,
      country: null,
      loading: false,
      countries: Countries
    }
  },
  watch: {
    name_text(newVal, oldVal) {
      if (newVal === null) {
        this.name_text = oldVal
      }
    }
  },
  computed: {},
  methods: {
    showInCountry() {
      this.resetInfo()
      this.$nextTick(() => this.$refs.postInput.focus())
    },
    showNotInCountry() {
      this.resetInfo()
      this.not_in_autralia = true
      this.$nextTick(() => this.$refs.countrySelect.focus())
    },
    resetInfo() {
      this.postcode = null
      this.not_in_autralia = false
      this.name_text = null
      this.country = null
      this.loading = false
      this.$emit('input', null)
    },
    async validate() {
      let result = await this.$validator.validateAll()
      if (result) this.getInfo()
      return !result ? false : true
    },
    getInfo() {
      const info = {
        postcode: !this.not_in_autralia ? this.postcode : null,
        country: this.not_in_autralia ? this.country : null,
        name: this.name_text
      }
      this.$emit('input', info)
      return info
    }
  }
}
</script>

<style scoped lang="scss"></style>
